export const EDIT_VALIDITY_FORM_ID = 'editValidityForm';

export const CREATE_VALIDITY_SUCCESS = 'CREATE_VALIDITY_SUCCESS';
export const CREATE_VALIDITY_ERROR = 'CREATE_VALIDITY_ERROR';

export const DELETE_VALIDITY_SUCCESS = 'DELETE_VALIDITY_SUCCESS';
export const DELETE_VALIDITY_ERROR = 'DELETE_VALIDITY_ERROR';
